import * as React from "react";
import { forwardRef } from "react";
const SvgList = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { className: "icon-svg", width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7,15.5 L12,15.5 M3,15.5 L5,15.5 M7,11.5 L16,11.5 M3,11.5 L5,11.5 M7,7.5 L21,7.5 M3,7.5 L5,7.5", stroke: "currentColor", strokeWidth: 1, fill: "none", fillRule: "evenodd" }));
const ForwardRef = forwardRef(SvgList);
export default ForwardRef;
